import { FormEventHandler, useState } from 'react'
import { Layout } from '../../shared/types'
import { Button } from '../components/button'
import { Input } from '../components/input'
import { Select } from '../components/select'
import { Textarea } from '../components/textarea'

type Props = {
	object: string
	data?: Layout
	onSubmit: FormEventHandler
	isPending?: boolean
}

const LAYOUT_TYPES = [
	{ value: 'table', label: 'Tabulka' },
	{ value: 'form', label: 'Formulář' },
	{ value: 'detail', label: 'Detail' },
	{ value: 'relation', label: 'Relace' },
]

export function ObjectLayoutsForm({ object, data, onSubmit, isPending }: Props) {
	const [configuration, setConfiguration] = useState(
		data?.configuration ? JSON.stringify(data.configuration, null, 2) : '{}',
	)

	const handleConfigurationChange = (value: string) => {
		setConfiguration(value)
	}

	return (
		<form className="space-y-4 m-auto max-w-[60em]" onSubmit={onSubmit}>
			<input type="hidden" name="object" value={object} />
			<h3 className="text-md font-bold">{data ? 'Editace rozložení' : 'Nové rozložení'}</h3>
			<div className="grid grid-cols-2 gap-4">
				<Select
					span="FULL"
					className="w-full col-span-2"
					label="Typ rozložení"
					name="type"
					isRequired
					options={LAYOUT_TYPES}
					defaultSelectedKey={data?.type}
				/>
				<Input
					label="Název"
					name="name"
					maxLength={255}
					isRequired
					defaultValue={data?.name || ''}
					className="col-span-2"
				/>
				<div className="col-span-2">
					<Textarea
						label="Konfigurace (JSON)"
						name="configuration"
						className="font-mono text-sm"
						textareaProps={{ rows: 15 }}
						value={configuration}
						onChange={handleConfigurationChange}
						isRequired
					/>
					<p className="text-xs text-slate-500 mt-1">
						Zadejte JSON konfiguraci pro rozložení. Například:{' '}
						{`{"columns": [], "actions": {}}`}
					</p>
				</div>
			</div>
			<Button type="submit" isPending={isPending} isDisabled={isPending}>
				Uložit
			</Button>
		</form>
	)
}
